export default "__VITE_ASSET__CmjU1_jc__"